import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FormSectionsComponent} from './form-sections.component';

const routes: Routes = [
  {
    path: '',
    component: FormSectionsComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormSectionsRoutingModule { }
